import { getField, updateField } from 'vuex-map-fields'

const state = {
  title: '',
  description: '',
  businessNumber: '',
}

const mutations = {
  updateField,
  reset(s) {
    s.title = ''
    s.description = ''
    s.businessNumber = ''
  },
}

const actions = {
  reset({ commit }) {
    commit('reset')
  },
}

const getters = {
  getField,
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true,
}
